import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Container } from '@sorare/core/src/atoms/layout/Container';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { MLBTeams } from '@sorare/core/src/lib/mlbTeams';
import { NBATeams } from '@sorare/core/src/lib/nbaTeams';

import { FootballClubs } from './FootballClubs';
import { FootballCompetitions } from './FootballCompetitions';
import { USSportClubs } from './USSportClubs';
import type { PartnersList_club } from './__generated__/index.graphql';

const Wrapper = styled(Vertical).attrs({ gap: 0 })`
  background: var(--c-black);
  color: var(--c-white);
`;

type Props = {
  footballClubs: Nullable<PartnersList_club[]>;
  sport: string | undefined;
  tab?: string;
  loading?: boolean;
};

export const PartnersList = ({ footballClubs, sport, tab, loading }: Props) => {
  const getContentView = () => {
    if (sport === 'nba') {
      return <USSportClubs clubs={NBATeams} sport={Sport.NBA} />;
    }
    if (sport === 'mlb') {
      return <USSportClubs clubs={MLBTeams} sport={Sport.BASEBALL} />;
    }
    if (tab === 'leagues') {
      return <FootballCompetitions />;
    }
    if (loading) {
      return <LoadingIndicator />;
    }
    return <FootballClubs clubs={footballClubs} />;
  };
  return (
    <Wrapper>
      <Container>{getContentView()}</Container>
    </Wrapper>
  );
};

PartnersList.fragments = {
  club: gql`
    fragment PartnersList_club on Club {
      slug
      ...FootballClubs_club
    }
    ${FootballClubs.fragments.club}
  ` as TypedDocumentNode<PartnersList_club>,
};
